"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Theme = require("../Theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  base: "border-2 font-500 tracking-0_2",
  centerAligned: "inline-flex items-center justify-center",
  size: {
    sm: "px-22 py-6 rounded-8 leading-1_5 text-0_875",
    md: "px-38 py-10 rounded-12 leading-1_5 text-1"
  },
  disabled: "opacity-50 cursor-not-allowed",
  primary: {
    default: {
      border: "border-transparent",
      bg: "bg-primary-3667e9",
      text: "text-white",
      hover: "hover:bg-primary-365fc1",
      focus: "focus:outline-3667e9"
    },
    danger: {
      border: "border-transparent",
      bg: "bg-red-c34648",
      text: "text-white",
      hover: "hover:bg-red-a6191c",
      focus: "focus:outline-3667e9"
    },
    dark: {
      border: "border-transparent",
      bg: "bg-primary-3667e9",
      text: "text-white",
      hover: "hover:bg-primary-365fc1",
      focus: "focus:outline-3667e9"
    }
  },
  secondary: {
    default: {
      border: "border-gray-e7e9ef",
      bg: "",
      text: "text-primary-3667e9",
      hover: "hover:outline-none hover:bg-gray-f3f4f7",
      focus: "focus:border-primary-3667e9 focus:shadow-0-0-0-4-cfe5ff focus:outline-none"
    },
    danger: {
      border: "border-red-c34648",
      bg: "",
      text: "text-red-c34648",
      hover: "hover:bg-gray-f3f4f7",
      focus: "focus:border-primary-3667e9 focus:shadow-0-0-0-4-cfe5ff focus:outline-none"
    },
    dark: {
      border: "border-gray-e7e9ef",
      bg: "",
      text: "text-primary-3667e9",
      hover: "hover:outline-none hover:bg-gray-f3f4f7",
      focus: "focus:border-primary-3667e9 focus:shadow-0-0-0-4-cfe5ff focus:outline-none"
    }
  },
  tertiary: {
    default: {
      border: "border-transparent",
      bg: "bg-transparent",
      text: "text-primary-3667e9",
      hover: "hover:outline-none hover:bg-gray-f3f4f7",
      focus: "focus:border-primary-3667e9 focus:shadow-0-0-0-4-cfe5ff focus:outline-none"
    },
    danger: {
      border: "border-transparent",
      bg: "bg-transparent",
      text: "text-red-c34648",
      hover: "hover:outline-none hover:bg-gray-f3f4f7",
      focus: "focus:border-primary-3667e9 focus:shadow-0-0-0-4-cfe5ff focus:outline-none"
    },
    dark: {
      border: "border-transparent",
      bg: "bg-transparent",
      text: "text-gray-65657b",
      hover: "hover:outline-none hover:bg-gray-f3f4f7",
      focus: "focus:border-primary-3667e9 focus:shadow-0-0-0-4-cfe5ff focus:outline-none"
    }
  }
};
const Button = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    variant = "primary",
    size = "md",
    color = "default",
    fullWidth = false,
    leadingIcon,
    trailingIcon,
    disabled,
    ...props
  } = _ref;
  const {
    primaryCtaColor,
    primaryCtaColorHover
  } = (0, _Theme.useThemeConfig)();
  const isPrimaryDefault = variant === "primary" && color === "default";
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    ref: ref,
    className: (0, _classnames.default)(THEME.base, THEME[variant][color].border, isPrimaryDefault && primaryCtaColor ? primaryCtaColor : THEME[variant][color].bg, THEME[variant][color].text, THEME.size[size], {
      [THEME.disabled]: disabled === true,
      [isPrimaryDefault && primaryCtaColorHover ? primaryCtaColorHover : THEME[variant][color].hover]: disabled !== true,
      [THEME[variant][color].focus]: disabled !== true,
      "w-full": fullWidth === true,
      [THEME.centerAligned]: leadingIcon || trailingIcon
    }, className),
    disabled: disabled
  }, props), leadingIcon ? /*#__PURE__*/_react.default.cloneElement(leadingIcon, {
    "aria-hidden": true,
    className: "inline-block mr-4"
  }) : "", children, trailingIcon ? /*#__PURE__*/_react.default.cloneElement(trailingIcon, {
    "aria-hidden": true,
    className: "inline-block ml-4"
  }) : "");
});
exports.Button = Button;
Button.displayName = "Button";